<template>
  <v-card elevation="2" :max-width="maxWidthCard" class="mx-auto mt-4 mb-3">
    <v-card-title> <v-icon>mdi-account-group</v-icon> Usuários</v-card-title>
    <v-card-text>
      <v-form ref="frm">
        <v-container fluid>
          <v-row>
            <v-col cols="12" lg="4" sm="4" class="d-flex ">
              <v-text-field
                v-model.trim="$v.user.user.$model"
                prepend-icon="mdi-email"
                name="email"
                autocomplete="off"
                :error-messages="userError"
                label="User"
                ref="inptemail"
                type="email"
              />
              <!-- <v-btn color="#4285f4" small dark @click="dialogLocal=true">Lista de locais</v-btn> -->
            </v-col>
            <v-col cols="12" lg="4" sm="4">
              <v-text-field
                :append-icon="showPwd ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPwd ? 'text' : 'password'"
                @click:append="showPwd = !showPwd"
                v-model.trim="$v.user.pwd.$model"
                :error-messages="pwdError"
                prepend-icon="mdi-lock"
                disable
                name="password"
                label="Senha"
              />
            </v-col>
            <v-col cols="12" lg="4" sm="4">
              <v-text-field
                :append-icon="showPwdRepita ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPwdRepita ? 'text' : 'password'"
                @click:append="showPwdRepita = !showPwdRepita"
                v-model.trim="$v.repwd.$model"
                :error-messages="rePwdError"
                prepend-icon="mdi-lock"
                disable
                name="password"
                label="Repita a Senha"
              />
            </v-col>
            <v-col cols="12" md="5">
              <v-select
                v-model="$v.user.hostId.$model"
                @blur="checkChangeLocal"
                :items="$store.getters.listHost"
                :error-messages="hostIdError"
                label="Local"
                item-text="descr"
                item-value="hostId"
                :return-object="false"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="7">
              <v-select
                v-model="$v.user.mod.$model"
                :items="modulos"
                label="Módulos"
                clearable
                open-on-clear
                multiple
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggle">
                    <v-list-item-action>
                      <v-icon
                        :color="$v.user.length > 0 ? 'indigo darken-4' : ''"
                        >{{ icon }}</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-alert
              border="left"
              colored-border
              elevation="1"
              color="color_alert"
              dense
              class="rounded-lg mb-4"
              :style="{ border: '1px solid #e0004d', 'border-radius': '20px' }"
            >
              <div class="py-2">
                <p class="font-weight-light my-0 text-body-2">
                  Confirme o local que seu usuário poderá acessar e selecione
                  nos módulosas permissões que ele poderá acessar e editar.
                </p>
              </div>
            </v-alert>
            <v-spacer />
            <v-col cols="12" col="4" class="d-flex align-content-end">
              <v-btn
                :disabled="$v.$invalid || disableSubmit ? true : false"
                color="primary"
                large
                type="submit"
                @click.prevent="submit"
              >
                Salvar
              </v-btn>
              <v-btn
                color="error"
                large
                type="reset"
                class="ml-2"
                @click.prevent="resetFrm"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-data-table
        :loading-text="textLoad"
        height="400"
        :loading="gridLoad"
        :headers="headers"
        :items="listUser"
        :hide-default-footer="true"
        item-key="user"
        fixed-header
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon color="warning" class="mx-1" @click="editUser(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" class="mx-1" @click="editUserDelete(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="dialogDelete" persistent max-width="360">
      <v-card>
        <v-card-title class="text-subtitle-2 text-uppercase">
          Aviso
        </v-card-title>
        <v-card-text>
          Deseja remover o usuário {{ userEdit.user }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red darken-1" text @click="dialogDelete = false">
            Cancelar
          </v-btn>
          <v-btn color="success darken-1" text @click="removerUser">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogLocal" persistent max-width="360">
      <v-card>
        <v-card-title class="text-subtitle-2 text-uppercase">
          Aviso
        </v-card-title>
        <v-card-text>
          {{msgTrocaLocal}}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { required, sameAs, email, requiredIf } from "vuelidate/lib/validators";
import { isEmpty } from "../../services/utils";

export default {
  name: "MeusUsuarios",
  data: () => {
    return {
      dialogLocal:false,
      hostIdTroca:'',
      msgTrocaLocal:'',
      user: {
        mod: [],
        user: "",
        hostId: "",
        pwd: "",
      },
      repwd: "",
      userEdit: {},
      dialogDelete: false,
      modulos: [
        { value: 5, text: "Descrição do local" },
        { value: 10, text: "Meus Dados" },
        { value: 20, text: "Usuários" },
        { value: 30, text: "Notificação" },
        { value: 40, text: "Alterar Senha" },
        // {value:50,text:'Minhas câmeras'},
        { value: 60, text: "Realizar configuração" },
        { value: 70, text: "Start/Stop" },
        { value: 80, text: "Minha Assinatura" },
        { value: 90, text: "Cancelar assinatura" },
        { value: 100, text: "Alterar/Excluir câmera" },
      ],
      headers: [
        { text: "User", value: "user", sortable: false },
        { text: "Ações", value: "actions", sortable: false },
      ],
      textLoad: "Aguarde, buscando informações",
      gridLoad: false,
      showPwd: false,
      showPwdRepita: false,
      listUser: [],
      maxWidthCard: "90%",
      disableBtn: false,
    };
  },
  validations: {
    user: {
      user: {
        required,
        email,
      },
      hostId: {
        required,
      },
      pwd: {
        required: requiredIf(function () {
          return (this.user.pwd == null || this.user.pwd.length <= 0) &&
            !isEmpty(this.userEdit)
            ? false
            : true;
        }),
      },
      mod: { required },
    },
    repwd: {
      required: requiredIf(function () {
        return (this.user.pwd == null || this.user.pwd.length <= 0) &&
          !isEmpty(this.userEdit)
          ? false
          : true;
      }),
      sameAsPassword: sameAs(function () {
        return this.user.pwd;
      }),
    },
  },
  computed: {
    userError() {
      const errors = [];
      const email = this.$v.user.user;
      if (!email.$dirty) {
        return errors;
      }
      !email.required && errors.push("User é obrigatório");
      !email.email && errors.push("User deve ser um e-email inválido");
      return errors;
    },
    hostIdError() {
      const errors = [];
      const email = this.$v.user.hostId;
      if (!email.$dirty) {
        return errors;
      }
      !email.required && errors.push("Local é obrigatório");
      return errors;
    },
    pwdError() {
      const errors = [];
      const password = this.$v.user.pwd;
      if (!password.$dirty) {
        return errors;
      }
      if (
        (this.user.pwd == null || this.user.pwd.length <= 0) &&
        !isEmpty(this.userEdit)
      ) {
        return errors;
      }
      !password.required && errors.push("Senha é obrigatório");
      return errors;
    },
    rePwdError() {
      const errors = [];
      const password = this.$v.repwd;
      if (!password.$dirty) {
        return errors;
      }
      if (
        (this.user.pwd == null || this.user.pwd.length <= 0) &&
        !isEmpty(this.userEdit)
      ) {
        return errors;
      }
      !password.required && errors.push("Nova Senha é obrigatorio");
      !password.sameAsPassword && errors.push(`As Senha devem ser iguais `);
      return errors;
    },
    disableSubmit: {
      set(value) {
        this.disableBtn = value;
      },
      get() {
        return this.disableBtn;
      },
    },
    likesAllFruit() {
      return this.user.mod.length === this.modulos.length;
    },
    likesSomeFruit() {
      return this.user.mod.length > 0 && !this.likesAllFruit;
    },
    icon() {
      if (this.likesAllFruit) return "mdi-close-box";
      if (this.likesSomeFruit) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    checkChangeLocal(){
      if(this.user.hostId != this.$store.getters.hostActive) {
        this.changeLogin()
      }
    },
    redirectLoginLocal(pagina) {
      this.$router
        .push({
          name: pagina,
          params: pagina != "login" ? { hostId: this.hostIdActive } : {},
        })
        .catch(() => {});
    },
    getDescricaoLocal(id){
      let name = ''
      this.$store.getters.listHost.forEach(value=>{
        if(value.hostId==id) {
          name = value.descr
        }
      })
      return name
    },
    changeLogin() {
      let email = this.$store.getters.getEmail;
      let data = {
        user: email,
        pwd: this.$store.getters.getLsPwd,
        hostId: this.user.hostId,
      };
      this.dialogLocal = true
      this.msgTrocaLocal = 'Entrando no local: '+this.getDescricaoLocal(data.hostId),
      this.$alertme.signIn(data).then(
        (res) => {
          //exibi msg
          if (res.data.message && res.data.message != "ok") {
            this.$store.dispatch("setMsgError", res.data.message);
            this.$store.dispatch("setDisplayMsgErr", true);
            this.redirectLoginLocal("login");
            return;
          }
          //
          this.$store.dispatch("MsgSucces", "Login efetuado com sucesso!");
          this.$store.dispatch("displayMsgSuccess", true);
          this.$store.dispatch("setHostActive",this.user.hostId);
          this.$store.dispatch("setToken", true);
          //
          let host = this.$alertme.getInfoHostUser(email, this.user.hostId);
          host.mod = res.data.mod;
          if (!this.$alertme.setAuthHostUser(email, this.user.hostId, host)) {
            this.$store.dispatch("setMsgError", "Erro ao realizar login");
            this.$store.dispatch("setDisplayMsgErr", true);
            return false;
          }
          //buscando perfil
          this.$alertme
            .getPerfil({ hostId: this.user.hostId })
            .then(
              (res) => {
                if (res.data.status) {
                  this.$store.dispatch("setPerfil", {});
                } else {
                  this.$store.dispatch("setPerfil", res.data.value);
                }
                //
                //
              },
              () => {
                this.$store.dispatch("setPerfil", {});
              }
            )
            .finally(() => {
              this.dialogLocal = false;
              this.redirectLoginLocal("usuarios");
            });
        },
        () => {
          this.dialogLocal = false;
          this.$store.dispatch("resetToken");
          this.$store.dispatch(
            "setMsgError",
            "Não foi possivel realizar login!"
          );
          this.$store.dispatch("setDisplayMsgErr", true);
          this.redirectLoginLocal("login");
        }
      );
    },
    resetFrm() {
      this.userEdit = {};
      this.$refs.frm.reset();
      this.$v.user.$reset();
      this.$v.user.$touch();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.user.mod = [];
        } else {
          this.user.mod = [];
          this.modulos.map((value) => {
            this.user.mod.push(value.value);
          });
        }
      });
    },
    removerUser() {
      this.dialogDelete = false;
      let data = {
        hostId: this.$alertme.getHostIdUrl(this.$route),
        user: this.userEdit.user,
      };
      this.$alertme.deleteUsuario(data).then(
        (res) => {
          this.disableSubmit = false;
          if (res.data.message.toLowerCase() == "ok") {
            this.$store.dispatch("MsgSucces", "Usuário deletado");
            this.$store.dispatch("displayMsgSuccess", true);
            this.$refs.frm.reset();
            this.$v.$reset();
            this.buscaUser();
            this.userEdit = {};
          } else {
            this.$store.dispatch("setMsgError", res.data.message);
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        },
        () => {
          this.disableSubmit = false;
        }
      );
    },
    editUserDelete(item) {
      this.dialogDelete = true;
      this.userEdit = Object.assign({}, item);
    },
    editUser(item) {
      this.userEdit = Object.assign({}, item);
      this.user.user = item.user;
      this.user.mod = item.mod;
      this.$v.$reset();
    },
    submit() {
      this.disableSubmit = true;
      let pwd =
        this.user.pwd == null || this.user.pwd.length <= 0
          ? null
          : this.$alertme.md5(this.user.pwd);
      if (!isEmpty(this.userEdit)) {
        if (
          this.user.pwd == null ||
          this.user.pwd.length <= 0 ||
          this.user.pwd == this.userEdit.pwd
        ) {
          pwd = this.userEdit.pwd;
        }
      }
      if (pwd == null) {
        this.$store.dispatch(
          "setMsgError",
          "Não foi informado a senha do usuário"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      let data = {
        hostId: this.$alertme.getHostIdUrl(this.$route),
        user: this.user.user,
        pwd: pwd,
        mod: [...this.user.mod],
      };

      this.$store.commit("setRedirect", "");
      this.$alertme
        .createUser(data)
        .then(
          (res) => {
            this.disableSubmit = false;
            if (res.data.message.toLowerCase() == "ok") {
              this.$store.dispatch(
                "MsgSucces",
                isEmpty(this.userEdit)
                  ? "Usuário cadastrado"
                  : "Usuário atualizado"
              );
              this.$store.dispatch("displayMsgSuccess", true);
              this.$refs.frm.reset();
              this.$v.$reset();
              this.buscaUser();
            } else {
              this.$store.dispatch("setMsgError", res.data.message);
              this.$store.dispatch("setDisplayMsgErr", true);
            }
          },
          () => {
            this.disableSubmit = false;
          }
        )
        .finally(() => {
          this.userEdit = {};
        });
    },
    buscaUser() {
      let data = {};
      this.gridLoad = true;
      data.hostId = this.$alertme.getHostIdUrl(this.$route);
      this.$alertme.listUsuarios(data).then(
        (res) => {
          this.gridLoad = false;
          this.listUser = [];
          if (res.data.message) {
            this.$store.dispatch("setMsgError", res.data.message);
            this.$store.dispatch("setDisplayMsgErr", true);
          } else {
            this.listUser = res.data;
          }
        },
        () => {
          this.gridLoad = false;
          this.$store.dispatch("setPerfil", {});
        }
      );
    },
  },
  props: ["maxWidth"],
  created() {
    this.maxWidthCard = !this.maxWidth ? "90%" : this.maxWidth;
    this.user.hostId = this.$store.getters.hostActive
    this.buscaUser();
  },
};
</script>